import React from "react";
import { Stack, Box, Typography, Button, Card, Select, MenuItem, ToggleButtonGroup, ToggleButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CampaignIcon from "@mui/icons-material/Campaign";

const AnnouncementsHeader = ({ statusFilter, onStatusFilterChange, selectedLang, onLanguageChange, onCreateNew }) => {
  return (
    <>
      {/* Page Title & Create Button */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CampaignIcon fontSize="large" color="primary" /> Announcements
          </Typography>
        </Box>
        <Button size="large" variant="contained" startIcon={<AddIcon />} onClick={onCreateNew} sx={{ borderRadius: 2 }}>
          New Announcement
        </Button>
      </Stack>

      {/* Filter bar */}
      <Card sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between">
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              Language:
            </Typography>
            <ToggleButtonGroup
              size="small"
              value={selectedLang}
              exclusive
              onChange={(e, val) => {
                if (val) onLanguageChange(val);
              }}
            >
              <ToggleButton value="en" sx={{ px: 1.5, py: 0.5, fontWeight: 700 }}>
                EN
              </ToggleButton>
              <ToggleButton value="es" sx={{ px: 1.5, py: 0.5, fontWeight: 700 }}>
                ES
              </ToggleButton>
              <ToggleButton value="pt" sx={{ px: 1.5, py: 0.5, fontWeight: 700 }}>
                PT
              </ToggleButton>
              <ToggleButton value="fr" sx={{ px: 1.5, py: 0.5, fontWeight: 700 }}>
                FR
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              Filter by Status:
            </Typography>
            <Select size="small" value={statusFilter} onChange={(e) => onStatusFilterChange(e.target.value)} sx={{ minWidth: 150 }}>
              <MenuItem value="ALL">All Statuses</MenuItem>
              <MenuItem value="PUBLISHED">Published</MenuItem>
              <MenuItem value="DRAFT">Draft</MenuItem>
            </Select>
          </Stack>
        </Stack>
      </Card>
    </>
  );
};

export default AnnouncementsHeader;
